import { useEffect, useState, ChangeEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { TextField, Button, CircularProgress } from "@mui/material";
import returnsLogo from "../../assets/images/returns-wealth-logo.png";

const Invite = () => {
    const navigate = useNavigate();
    const { invite_id } = useParams();
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [error, setError] = useState("");

    const validatePhoneNumber = (number: string) => {
        return /^[0-9]{10}$/.test(number);
    };

    const handleConfirm = async () => {
        if (!validatePhoneNumber(phoneNumber)) {
            setError("Please enter a valid 10-digit phone number");
            return;
        }
        setError("");
        setIsLoading(true);
        try {
            const currentDate = new Date().toISOString();
            await axios.post(
                "https://tradeinsights.co.in/v1/api/invites/updateacceptedmerge",
                {
                    invite_id,
                    accepted: { [phoneNumber]: currentDate }
                },
                {
                    headers: {
                        Authorization: "ffjngfbfbvfkw4865427959249"
                    }
                }
            );
            setIsConfirmed(true);
        } catch (error) {
            console.error("Error accepting invite:", error);
            setError("Failed to accept invitation. Please try again.");
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (isConfirmed) {
            const userAgent = navigator.userAgent || navigator.vendor;

            if (/android/i.test(userAgent)) {
                window.location.href = "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
            } else if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
                window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
            } else {
                window.location.href = "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
            }
        }
    }, [isConfirmed]);

    if (!invite_id) {
        return <div className="error">Invalid invite link</div>;
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl overflow-hidden border border-white/20">
                    {/* Header section */}
                    <div style={{ 
                        marginTop: '26px', 
                        marginBottom: '48px', 
                        padding: '0 32px', 
                        textAlign: 'center' 
                    }}>
                        <div style={{ marginBottom: '24px' }}>
                            <img 
                                src={returnsLogo} 
                                alt="Returns" 
                                style={{ 
                                    height: '32px', 
                                    margin: '0 auto',
                                    marginBottom: '12px'
                                }} 
                            />
                        </div>
                        
                        <h2 style={{ 
                            fontSize: '30px', 
                            fontWeight: 'bold', 
                            color: 'white', 
                            marginBottom: '12px',
                            opacity: '0.8'
                        }}>
                            Exclusive Invite Access!
                        </h2>
                        <p style={{ color: '#D1D5DB' }}>
                            You're one step away from joining our community.
                        </p>
                    </div>
                    


                    {/* Main content */}
                    <div className="p-8 pt-0 bg-white/5" >
                        <div className="flex flex-col items-center w-full">
                            <div className="flex justify-center w-full mb-6">
                                <TextField
                                    variant="outlined"
                                    label="Phone Number"
                                    value={phoneNumber}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                                    placeholder="Enter your 10-digit phone number"
                                    InputProps={{
                                        startAdornment: <span className="text-gray-400 mr-2">+91</span>,
                                        className: "bg-white/10 text-white",
                                    }}
                                    InputLabelProps={{
                                        className: "text-gray-300",
                                    }}
                                    error={!!error}
                                    helperText={error}
                                    sx={{
                                        width: '300px',
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: 'rgba(255, 255, 255, 0.2)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'rgba(255, 255, 255, 0.3)',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'rgba(255, 255, 255, 0.5)',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            color: 'white',
                                            '&::placeholder': {
                                                color: 'rgba(255, 255, 255, 0.5)',
                                                opacity: 1,
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'rgba(255, 255, 255, 0.7)',
                                            '&.Mui-focused': {
                                                color: 'rgba(255, 255, 255, 0.7)',
                                            },
                                        },
                                    }}
                                />
                            </div>

                            <div className="flex justify-center w-full">
                                <Button
                                    variant="contained"
                                    onClick={handleConfirm}
                                    disabled={isLoading || phoneNumber.length !== 10}
                                    sx={{
                                        width: '300px',
                                        py: 1.5,
                                        background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.15) 30%, rgba(255, 255, 255, 0.25) 90%)',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        '&:hover': {
                                            background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2) 30%, rgba(255, 255, 255, 0.3) 90%)',
                                            color: 'white',
                                        },
                                        '&.Mui-disabled': {
                                            background: 'rgba(255, 255, 255, 0.12)',
                                            color: 'rgba(255, 255, 255, 0.3)',
                                        },
                                    }}
                                >
                                    {isLoading ? (
                                        <CircularProgress size={24} sx={{ color: 'black' }} />
                                    ) : (
                                        'Join Returns'
                                    )}
                                </Button>
                            </div>

                            <div className="flex justify-center w-full mt-6">
                                <div className="w-[80%] max-w-[400px]">
                                    <p className="text-center text-gray-400" style={{ fontSize: '10px' }}>
                                        By joining, you agree to our{' '}
                                        <a 
                                            href="https://docs.google.com/document/u/0/d/107oGESPJbd231S9_EKlYOFqG6jjUkrGcJDBCD8wKW_4/mobilebasic?pli=1"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-gray-300 hover:text-white"
                                            style={{ fontSize: '10px' }}
                                        >
                                            Terms of Service
                                        </a>
                                        {' '}and{' '}
                                        <a 
                                            href="https://docs.google.com/document/u/5/d/10_9GANOQ1rBtdjlIKuaRwco_TikyA9WAdAna0hodylg/mobilebasic"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-gray-300 hover:text-white"
                                            style={{ fontSize: '10px' }}
                                        >
                                            Privacy Policy
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Invite;
